module.exports = __webpack_public_path__ + "static/media/07-baby-default.22ee964b.png";